import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { promotionKeys } from "./query-keys";

export interface UpsertPromotionVars {
  id: string;
  body: components["schemas"]["PromotionUpsertRequest"];
}

/** PUT /v1/promotions/{id} — full update incl. rule replacement. */
export function useUpsertPromotion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, body }: UpsertPromotionVars) => {
      const { data, error } = await apiClient.PUT("/v1/promotions/{id}", {
        params: { path: { id } },
        body,
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
    onSuccess: (_data, { id }) => {
      void qc.invalidateQueries({ queryKey: promotionKeys.promotion(id) });
      void qc.invalidateQueries({ queryKey: promotionKeys.all });
    },
  });
}
